import { ChangeDetectionStrategy, Component, EventEmitter, Inject, Input, Output } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TAction } from './interfaces/form-actions';

@Component({
  selector: 'app-form-control-popup',
  templateUrl: './form-control-popup.component.html',
  styleUrls: ['./form-control-popup.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FormControlPopupComponent {
  form!: FormGroup;
  action: TAction = 'create';

  @Input() name: string = 'SALES_LEADGENERATION_CONVERSION_TITLE';
  @Output() onClose: EventEmitter<void> = new EventEmitter<void>();

  constructor(
    private _fb: FormBuilder,
    private dialogRef: MatDialogRef<FormControlPopupComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {}

  ngOnInit() {
    this.action = this.data.action;
    this.form = this._fb.group({
      name: [this.data.name, []],
      value: [this.data.value, []],
    });
  }

  save() {
    this.dialogRef.close({
      value: this.form.value,
      action: this.action,
    });
  }

  close() {
    this.dialogRef.close();
  }

  reset() {
    this.form.reset();
    this.action = 'delete';
    this.dialogRef.close({
      value: this.form.value,
      action: this.action,
      id: this.data.id,
    });
  }
}
